import axios from "../config/axios";
import toast from "react-hot-toast";
import { UserApi } from "../Utils/Api";

export const SET_USER = "SET_USER";
export const SET_TOKEN = "SET_TOKEN";
export const SET_REFERRAL_CODE = "SET_REFERRAL_CODE";
export const SET_USER_PAY = "SET_USER_PAY";
export const CLEAR_USER = "CLEAR_USER";

export const setUser = (user) => ({
  type: SET_USER,
  payload: { user },
});

export const setToken = (token) => ({
  type: SET_TOKEN,
  payload: { token },
});

export const setUserPay = (formData) => ({
  type: SET_USER_PAY,
  payload: { formData },
});

export const clearUser = () => ({
  type: CLEAR_USER,
});
export const setReferralCode = (referralCode) => ({
  type: SET_REFERRAL_CODE,
  payload: { referralCode },
});

export const loginWithEmail = (email, password) => async (dispatch) => {
  toast.loading("Please Wait ...");

  try {
    const response = await axios.post(UserApi.EmailLogin, {
      email,
      password,
    });
    const { user, token } = response.data;
    dispatch(setUser(user));
    dispatch(setToken(token));
    toast.success("Login successful!");
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Login failed. Please try again.";
    toast.error(errorMessage); // Notify error
    // console.error("Login Error:", errorMessage);
  } finally {
    toast.dismiss();
  }
};
export const loginWithGoogle = (tokenId) => async (dispatch) => {
  let isApiCallComplete = false;

  const firstToast = toast.loading("Please Wait ...", {
    position: "top-center",
    duration: 1500,
  });

  let secondToastId = null;

  const secondToastTimeout = setTimeout(() => {
    if (!isApiCallComplete) {
      toast.dismiss(firstToast);
      secondToastId = toast.loading("Please Refresh and try again ...", {
        position: "top-center",
      });
    }
  }, 1500);

  try {
    const response = await axios.post(UserApi.GoogleLogin, {
      access_token: tokenId.access_token,
    });

    const { user, token } = response.data;
    dispatch(setUser(user));
    dispatch(setToken(token));

    isApiCallComplete = true;
    toast.dismiss(firstToast);
    clearTimeout(secondToastTimeout);

    if (secondToastId) toast.dismiss(secondToastId);

    toast.success("Login successful!", {
      position: "top-center",
    });

    return { user, token };
  } catch (error) {
    isApiCallComplete = true;
    const errorMessage = "Google login failed. Please try again.";

    toast.dismiss(firstToast);
    clearTimeout(secondToastTimeout);

    // Dismiss second toast if it was shown
    if (secondToastId) toast.dismiss(secondToastId);

    toast.error(errorMessage, {
      position: "top-center",
    });

    throw error;
  }
};

export const logout = () => (dispatch) => {
  dispatch(clearUser());
  toast.success("Logged out successfully!");
};
